<div *ngIf="stageSpinner" class="imageCenter">
    <mat-spinner diameter="30" id="stages"></mat-spinner>  
  </div>
<mat-accordion displayMode="flat" togglePosition="before" class="mat-list-custom" *ngIf="!stageSpinner">
    <mat-expansion-panel togglePosition="before" displayMode="flat" [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title class="m-0">
              <span class="flex-fill"> Properties </span>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <form [formGroup]="workFlowStageForm">
            <mat-form-field class="w-100" appearance="outline">
                <mat-label>Stage Name</mat-label>
                <input matInput placeholder="WorkFlow Name" formControlName="name" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="mt-2 w-100">
                <mat-label>Page</mat-label>
                <mat-select matNativeControl formControlName="page" placeholder="Select Page">
                    <ng-container *ngFor="let item of pageListDropdown">
                        <mat-option [value]="item.pageId">{{ item.pageName | titlecase}}</mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>
            <div class="toggle-container">
                <label id="stageType">Stage Type</label>
                <mat-radio-group MatRadioButton aria-label="Stage Type" class="d-flex" formControlName="stageType">
                    <mat-radio-button value="optional">Optional</mat-radio-button>
                    <mat-radio-button value="mandatory">Mandatory</mat-radio-button>
                </mat-radio-group>
            </div>
            <mat-form-field appearance="outline" class="mt-2 w-100">
                <mat-label>Access Role</mat-label>
                <mat-select matNativeControl formControlName="accessrole" placeholder="Select Role">
                    <ng-container *ngFor="let role of roleList">
                        <mat-option [value]="role.roleId">{{ role.roleName | titlecase}}</mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>

            <div class="toggle-container">
                <label id="accessType">Approval Type</label>
                <mat-radio-group MatRadioButton aria-label="Access Type" class="d-flex" formControlName="approvalType">
                    <mat-radio-button value="reporting">Reporting</mat-radio-button>
                    <mat-radio-button value="role">Role</mat-radio-button>
                </mat-radio-group>
            </div>

            <mat-form-field appearance="outline" class="mt-2 w-100" *ngIf="isRoleAccess">
                <mat-label>Role</mat-label>
                <mat-select matNativeControl formControlName="role" placeholder="Select Role">
                    <ng-container *ngFor="let role of roleList">
                        <mat-option [value]="role.roleId">{{ role.roleName | titlecase}}</mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>
        </form>
    </mat-expansion-panel>

    <mat-expansion-panel togglePosition="before" displayMode="flat" [expanded]="false">
        <mat-expansion-panel-header>
            <mat-panel-title class="m-0">
              <span class="flex-fill"> Validation </span>
            </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-container [formGroup]="stageValidationForm">
            <div class="toggle-container">
                <label id="accessType">Acceptance Criteria</label>
                <span class="d-flex">
                    <mat-checkbox formControlName="approval">Approval</mat-checkbox>
                    <mat-checkbox formControlName="folds">Itteration</mat-checkbox>
                </span>
            </div>
    
            <mat-form-field class="w-100" appearance="outline" *ngIf="isApproval">
                <mat-label>Approval Levels</mat-label>
                <input type="number" matInput placeholder="Approval Levels" formControlName="nApproval" />
            </mat-form-field>

            <mat-form-field class="w-100" appearance="outline" *ngIf="isFolds">
                <mat-label>No. of Itterations</mat-label>
                <input type="number" matInput placeholder="No. of Folds" formControlName="nFolds" />
            </mat-form-field>
        </ng-container>


    </mat-expansion-panel>

    <mat-expansion-panel togglePosition="before" displayMode="flat" [expanded]="false">
        <mat-expansion-panel-header>
            <mat-panel-title class="m-0">
              <span class="flex-fill"> Action </span>
            </mat-panel-title>
        </mat-expansion-panel-header>
        
        <ng-container  [formGroup]="stageActionForm">
            <mat-form-field appearance="outline" class="mt-2 w-100">
                <mat-label>Select Action Type</mat-label>
                <mat-select matNativeControl formControlName="actionType" placeholder="Select Action Type">
                    <ng-container *ngFor="let action of actionType">
                        <mat-option [value]="action">{{ action | titlecase}}</mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>
        
            <mat-form-field appearance="outline" class="mt-2 w-100" *ngIf="isNextStage">
                <mat-label>Select Next Stage</mat-label>
                <mat-select matNativeControl formControlName="nextStage" placeholder="Select Next Stage">
                    <ng-container *ngFor="let stage of stageList">
                        <mat-option [value]="stage.stage_id">{{ stage.stage_name |titlecase}}</mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>
        </ng-container>
    </mat-expansion-panel>
</mat-accordion>

<div class="p-3" *ngIf="!stageSpinner">
    @if([appPermissions.editEntity,permissionsActions.edit] | builderPermissions){
        <button mat-stroked-button color="primary" class="add-button w-100 " (click)="saveStage()">
            Update Stage Configuration
        </button>
    }
</div>